import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
// import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';
import auth from '../../../common/utility/auth';

const REGISTRADO = 1;
const APROBADO = 2;
const ENPROCESO = 3;
const ANULADO = 4;
const FINALIZADO = 5;
export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idCreditoEstado === REGISTRADO)
            return 'blue';
        if (row.idCreditoEstado === APROBADO)
            return 'green';
        if (row.idCreditoEstado === ENPROCESO)
            return 'orange';
        if (row.idCreditoEstado === ANULADO)
            return 'red';
        if (row.idCreditoEstado === FINALIZADO)
            return '#28a745';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    disabled={row.idCreditoEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Aprobar">
                                <Button
                                    type="success"
                                    icon="check"
                                    size={"small"}
                                    loading={props.loadingCheck}
                                    disabled={row.idCreditoEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    disabled={row.idCreditoEstado === REGISTRADO ? false : true}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Ver Detalle">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    disabled={(row.idCreditoEstado === REGISTRADO || row.idCreditoEstado === ANULADO) ? true : false}
                                    loading={props.loadingDetails}
                                    onClick={() => props.onDetails(row)}
                                />
                            </Tooltip>

                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    loading={props.loadingPrint}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Nro Crédito',
                    dataIndex: 'serieDocumento',
                    key: 'serieDocumento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Número Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Tipo Crédido',
                    dataIndex: 'tipoCredito',
                    key: 'tipoCredito',
                    sorter: true
                },
                {
                    title: 'Nro Contrato',
                    dataIndex: 'nroContrato',
                    key: 'nroContrato',
                    sorter: true
                },
                {
                    title: 'Vendedor',
                    dataIndex: 'vendedor',
                    key: 'vendedor',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Crédito Asignado',
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    sorter: true,
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreCreditoEstado',
                    key: 'nombreCreditoEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}